import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hire-joomla-dev',
  templateUrl: './hire-joomla-dev.component.html',
  styleUrls: ['./hire-joomla-dev.component.css']
})
export class HireJoomlaDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/hire-joomla-dev/hire-joomla-dev.component.ts